import React, { Component } from 'react';

import { Paper, Typography } from 'material-ui';

import { Accent, Primary } from '../helper/consts';

import DemoAnimatedIcon from './DemoAnimatedIcon';

const style = {
	infoCard: {
		padding: '18px 36px',
		borderRadius: '20px',
		margin: '50px 0',
		display: 'flex',
		flexDirection: 'column'
	},
	infoCardTitle: {
		color: `${Accent}`,
		padding: '0 0 5px 0px',
		lineHeight: '30px',
		fontSize: '25px'
	},
	infoCardMessage: {
		color: `${Primary}`,
		padding: '25px 0'
	}
};

export default class LandingPageInfoCard extends Component {
	render() {
		const { icon, title, message } = this.props;
		return (
			<Paper style={style.infoCard} elevation={20}>
				<DemoAnimatedIcon icon={icon} />
				<Typography style={style.infoCardTitle} type="display1" component="h3">
					{title}
				</Typography>
				<Typography style={style.infoCardMessage} type="subheading">
					{message}
				</Typography>
			</Paper>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/LandingPageInfoCard.js